import { render, staticRenderFns } from "./payResultPage.vue?vue&type=template&id=792ffa95&scoped=true"
import script from "./payResultPage.vue?vue&type=script&lang=js"
export * from "./payResultPage.vue?vue&type=script&lang=js"
import style0 from "./payResultPage.vue?vue&type=style&index=0&id=792ffa95&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ffa95",
  null
  
)

export default component.exports